// extracted by mini-css-extract-plugin
module.exports = {"TabletContainer":"tablet_TabletContainer__2MzzX"};